export const makUpForKaiJiangList = (kaiJiangHaoMaList, lotteryType) => {
  const formatKaiJiangList = JSON.parse(JSON.stringify(kaiJiangHaoMaList))
  const pk10DefaultKeys = ['id', 'period', 'balls', 'drawTime', 'drawDate', 'hmDaXiao', 'hmDanShuang', 'zuLongHu', 'guanYaHe', 'guanYaHeDanShuang', 'guanYaHeDaXiao']
  const sscDefaultKeys = ['id', 'period', 'balls', 'drawTime', 'drawDate', 'hmDaXiao', 'hmDanShuang', 'zongHe', 'zongHeDanShuang', 'zongHeDaXiao', 'longHu', 'singTai']
  const k3DefaultKeys = ['id', 'period', 'balls', 'drawTime', 'drawDate', 'hmDaXiao', 'hmDanShuang', 'zongHe', 'zongHeDanShuang', 'zongHeDaXiao', 'haiSian']
  const xy28DefaultKeys = ['id', 'period', 'balls', 'drawTime', 'drawDate', 'zongHe', 'zongHeDanShuang', 'zongHeDaXiao', 'zongHeJiZhi', 'singTai', 'seBo']
  const kl8DefaultKeys = ['id', 'period', 'balls', 'drawTime', 'drawDate', 'hmDaXiao', 'hmDanShuang', 'hmDaXiaoPan', 'hmDanShuangPan', 'zongHe', 'zongHeDanShuang', 'zongHeDaXiao', 'wuXing']
  const kl10DefaultKeys = ['id', 'period', 'balls', 'drawTime', 'drawDate', 'hmDaXiao', 'hmDanShuang', 'zuLongHu', 'zongHe', 'zongHeDanShuang', 'zongHeDaXiao']
  const othersDefaultKeys = ['id', 'period', 'drawTime', 'drawDate', 'balls', 'zongHe', 'zongHeDanShuang', 'zongHeDaXiao']
  switch (lotteryType) {
    case 'kl8':
      formatKaiJiangList.forEach(each => {
        kl8DefaultKeys.forEach(key => {
          switch (key) {
            case 'id':
            case 'period':
            case 'drawTime':
            case 'drawDate':
            case 'hmDaXiaoPan':
            case 'hmDanShuangPan':
              if (!each[key]) each[key] = ''
              break
            case 'balls':
            case 'hmDaXiao':
            case 'hmDanShuang':
            case 'zongHe':
            case 'zongHeDanShuang':
            case 'zongHeDaXiao':
            case 'wuXing':
              if (!each[key]) each[key] = []
              break
          }
        })
      })
      return formatKaiJiangList
    case 'pk10':
      formatKaiJiangList.forEach(each => {
        pk10DefaultKeys.forEach(key => {
          switch (key) {
            case 'id':
            case 'period':
            case 'drawTime':
            case 'drawDate':
            case 'guanYaHe':
              if (!each[key]) each[key] = ''
              break
            case 'balls':
            case 'hmDaXiao':
            case 'hmDanShuang':
            case 'zuLongHu':
            case 'guanYaHeDanShuang':
            case 'guanYaHeDaXiao':
              if (!each[key]) each[key] = []
              break
          }
        })
      })
      return formatKaiJiangList
    case 'ssc':
    case '11x5':
      formatKaiJiangList.forEach(each => {
        sscDefaultKeys.forEach(key => {
          switch (key) {
            case 'id':
            case 'period':
            case 'drawTime':
            case 'drawDate':
            case 'longHu':
              if (!each[key]) each[key] = ''
              break
            case 'balls':
            case 'hmDaXiao':
            case 'hmDanShuang':
            case 'zongHe':
            case 'zongHeDanShuang':
            case 'zongHeDaXiao':
            case 'singTai':
              if (!each[key]) each[key] = []
              break
          }
        })
      })
      return formatKaiJiangList
    case 'k3':
      formatKaiJiangList.forEach(each => {
        k3DefaultKeys.forEach(key => {
          switch (key) {
            case 'id':
            case 'period':
            case 'drawTime':
            case 'drawDate':
              if (!each[key]) each[key] = ''
              break
            case 'balls':
            case 'zongHe':
            case 'zongHeDanShuang':
            case 'zongHeDaXiao':
            case 'haiSian':
              if (!each[key]) each[key] = []
              break
          }
        })
      })
      return formatKaiJiangList
    case 'xy28':
      formatKaiJiangList.forEach(each => {
        xy28DefaultKeys.forEach(key => {
          switch (key) {
            case 'id':
            case 'period':
            case 'drawTime':
            case 'drawDate':
            case 'zongHeJiZhi':
              if (!each[key]) each[key] = ''
              break
            case 'balls':
            case 'zongHe':
            case 'zongHeDanShuang':
            case 'zongHeDaXiao':
            case 'singTai':
            case 'seBo':
              if (!each[key]) each[key] = []
              break
          }
        })
      })
      return formatKaiJiangList
    case 'kl10':
      formatKaiJiangList.forEach(each => {
        kl10DefaultKeys.forEach(key => {
          switch (key) {
            case 'id':
            case 'period':
            case 'drawTime':
            case 'drawDate':
              if (!each[key]) each[key] = ''
              break
            case 'balls':
            case 'hmDaXiao':
            case 'hmDanShuang':
            case 'zuLongHu':
            case 'zongHe':
            case 'zongHeDanShuang':
            case 'zongHeDaXiao':
              if (!each[key]) each[key] = []
              break
          }
        })
      })
      return formatKaiJiangList
    case 'others':
      formatKaiJiangList.forEach(each => {
        othersDefaultKeys.forEach(key => {
          switch (key) {
            case 'id':
            case 'period':
            case 'drawTime':
            case 'drawDate':
              if (!each[key]) each[key] = ''
              break
            case 'balls':
            case 'zongHe':
            case 'zongHeDanShuang':
            case 'zongHeDaXiao':
              if (!each[key]) each[key] = []
              break
          }
        })
      })
      return formatKaiJiangList
  }
}

export const lotteryTypeStyleMapping = (ballsArr, lotteryCode, lotteryType) => {
  let returnArray = []
  switch (lotteryType) {
    case 'pk10':
      returnArray = ballsArr.reduce((acc, nothing, index) => {
        const ballIndex = index + 1
        acc[ballIndex] = ballIndex < 10 ? `ball-0${ballIndex}` : `ball-${ballIndex}`
        return acc
      }, {})
      return {
        lotteryClass: 'square-ball pk10-ball',
        ballClass: returnArray
      }
    case 'ssc':
    case '11x5':
    case 'kl10':
      returnArray = ballsArr.map((nothing, index) => 'ball-blue')
      return {
        lotteryClass: 'round-ball',
        ballClass: returnArray
      }
    case 'kl8':
      returnArray = ballsArr.map((nothing, index) => 'ball-blue')
      return {
        lotteryClass: 'round-ball mulitline',
        ballClass: returnArray,
        mulitline: true
      }
    case 'others':
      switch (lotteryCode) {
        case 'fcssq':
        case 'qlc':
          returnArray = ballsArr.map((nothing, index) => {
            if (index < ballsArr.length - 1) return 'ball-red'
            else return 'ball-blue'
          })
          return {
            lotteryClass: 'round-ball img_balls',
            ballClass: returnArray
          }
        case 'cjdlt':
          returnArray = ballsArr.map((nothing, index) => {
            if (index < ballsArr.length - 2) return 'ball-red'
            else return 'ball-blue'
          })
          return {
            lotteryClass: 'round-ball img_balls',
            ballClass: returnArray
          }
        case 'pl3':
        case 'pl5':
        case 'fc3d':
          returnArray = ballsArr.map((nothing, index) => 'ball-red')
          return {
            lotteryClass: 'round-ball img_balls',
            ballClass: returnArray
          }
        case 'qxc':
        case 'shssc':
          returnArray = ballsArr.map((nothing, index) => 'ball-red')
          return {
            lotteryClass: 'round-ball img_balls',
            ballClass: returnArray
          }
      }
  }
}

export const getLotteryRuleList = (lotteryType) => {
  switch (lotteryType) {
    case 'pk10':
      return 'hmDaXiao,hmDanShuang,zuLongHu,guanYaHe,guanYaHeDanShuang,guanYaHeDaXiao'
    case 'ssc':
      return 'hmDaXiao,hmDanShuang,zongHe,zongHeDanShuang,zongHeDaXiao,longHu,singTai'
    case '11x5':
      return 'hmDaXiao,hmDanShuang,zongHe,zongHeDanShuang,zongHeDaXiao,longHu,singTai'
    case 'k3':
      return 'hmDaXiao,hmDanShuang,zongHe,zongHeDanShuang,zongHeDaXiao,haiSian'
    case 'xy28':
      return 'zongHe,zongHeDanShuang,zongHeDaXiao,zongHeJiZhi,singTai,seBo'
    case 'kl8':
      return 'hmDaXiao,hmDanShuang,hmDaXiaoPan,hmDanShuangPan,zongHe,zongHeDanShuang,zongHeDaXiao,wuXing'
    case 'kl10':
      return 'hmDaXiao,hmDanShuang,zuLongHu,zongHe,zongHeDanShuang,zongHeDaXiao'
    case 'others':
      return 'zongHe,zongHeDanShuang,zongHeDaXiao'
    default:
      console.warn(`[getLotteryRuleList]沒有matched到對應的彩種類型 ${lotteryType}, 將回傳空陣列...`)
      return []
  }
}

export const addRuleClass = (pingyin) => {
  switch (pingyin) {
    case '大':
    case '双':
    case '极大':
    case '红':
    case '鱼':
    case '鸡':
    case '龙':
    case '顺子':
    case '对子':
      return 'td-text-red'
    case '绿':
    case '虾':
    case '蟹':
      return 'td-text-green'
    case '蓝':
    case '葫卢':
    case '金钱':
      return 'td-text-blue'
    default:
      return ''
  }
}
